import { DropdownMenuTrigger } from "@radix-ui/react-dropdown-menu";
import { Table } from "@tanstack/react-table";
import { Filter, Settings2 } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { useDialogModal } from "@/hook/handle-modal/hooks/actions";
import { ModalAdvancedFilters } from "./modal-filters/index";

interface DataTableViewOptionsProps<TData> {
  table: Table<TData>;
}

export function DataTableViewOptions<TData>({
  table,
}: DataTableViewOptionsProps<TData>) {
  const { handleModal } = useDialogModal();

  const handleOpenModal = () => {
    handleModal({
      isOpen: true,
      element: <ModalAdvancedFilters />,
      title: "Filtros Avançados",
    });
  };

  const columnNames = {
    cashier: "Caixa",
    store: "Loja",
    release_sequence: "Sequência",
    operation_type: "Tipo de Operação",
    operation_number: "Número",
    operator: "Operador",
    nsu_tef: "NSU",
    value: "Valor",
    operation_date: "Data",
    has_refund: "Possui Devolução",
  };

  return (
    <div className="flex gap-4">
      <Button
        variant="outline"
        size="sm"
        className="ml-auto hidden h-8 lg:flex"
        onClick={handleOpenModal}
      >
        <Filter />
        Filtros Avançados
      </Button>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="outline"
            size="sm"
            className="ml-auto hidden h-8 lg:flex"
          >
            <Settings2 />
            Visualizar
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-[150px]">
          <DropdownMenuLabel>Colunas</DropdownMenuLabel>
          <DropdownMenuSeparator />
          {table
            .getAllColumns()
            .filter(
              (column) =>
                typeof column.accessorFn !== "undefined" && column.getCanHide()
            )
            .map((column) => {
              return (
                <DropdownMenuCheckboxItem
                  key={column.id}
                  className="capitalize"
                  checked={column.getIsVisible()}
                  onCheckedChange={(value) => column.toggleVisibility(!!value)}
                >
                  {columnNames[column.id as keyof typeof columnNames] ?? "item"}
                </DropdownMenuCheckboxItem>
              );
            })}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}